import { z } from "zod";
import { managedUserSchema } from "./managedUser";

export const inviteUserSchema = z
  .object({ email: z.string().email() })
  .and(managedUserSchema);

export type InviteUserSchema = z.infer<typeof inviteUserSchema>;
